<template>
    <div>
        <PageHeader>
            {{ $t('ReportsSales') }}
        </PageHeader>
    </div>
</template>



<script>
    export default {
        name: 'ReportsSales',
        data() {
            return {};
        },
    };
</script>



<style lang="scss" scoped></style>
